import { ID } from '../../../global';
import { Page, PageParam } from '@/models/common';

export abstract class DataSource<T, FilterValue extends object = {}> {
  pageInfo: Page = { current: 1, pageSize: 10, total: 0 };

  dataFilter: (data: T) => boolean;
  constructor() {}

  abstract getEntity(id: ID): Promise<T>;
  abstract getList(options?: { pageParam?: PageParam; filter?: FilterValue }): Promise<T[]>;
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  getViewList(options?: {
    pageParam?: PageParam;
    filter?: FilterValue;
    value: (T | ID)[];
  }): Promise<T[]> {
    // options;
    return Promise.reject(new Error('Method not implemented.'));
  }
  abstract getLabel(entity: T): React.ReactNode;
  /**用于 rowKey  */
  abstract getKey(entity: T): ID;
  abstract getValue(entity: T): ID;
  abstract getPageInfo(): Page;
}
